import {Injectable} from '@angular/core';
import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {StreamStatus} from './stream-status.model';


@Injectable({providedIn: 'root'})
export class StreamStatusesService {

  constructor(
    private apiService: ApiService
  ) {
  }

  public getAll(): Observable<StreamStatus[]> {
    return this.apiService.get<StreamStatus[]>('/streams/statuses');
  }
}
